import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { BiCheck } from "react-icons/bi";
import { AlertFillIcon } from '@primer/octicons-react';
import { useTranslation } from 'react-i18next';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import configInfo from '../config/config.json';
import TemplateListView    from "./TemplateListView";
import PermissionAdminDetailsView from "./PermissionAdminDetailsView";
//import PermissionAdminNewView     from "./PermissionAdminNewView";


const PermissionAdmin = () => {

  const { t }       = useTranslation(["common","custom"]);
  const { user }    = useContext(UserContext);
  const navigate    = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "PermissionAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Perm_code"),
      sortable: true,
      sortField: 'nameCode',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 5,
      wrap: true
    },
    {
      name: t("I18N_Data_integrity"),
      cell: row => (
        !row.dataIntegrity ? <><span style={{color: 'red'}}>  <AlertFillIcon size={16} /></span>  <span style={{marginLeft:'5px', color: 'red'}}>  {t("I18N_Integrity_check_failed")} </span></> :
                             <><span style={{color: 'green'}}><BiCheck size={16} />      </span>  <span style={{marginLeft:'5px', color: 'green'}}>{t("I18N_Integrity_check_success")}</span></>
      ),
      grow: 0.5,
      omit: !configInfo.appConfig.checkDataIntegrity
    }
  ];

  // ----- END - Data Table stuff -----

  const objListPostProcessing = (objList) => {

    for (let i=0; i<objList.length; i++) {
      objList[i].code = objList[i].nameCode;
    }

    return (objList);
  }

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_IDENT_MGMT_API} apiObjName={'permissions'}
                                                  listPageTitle={t("I18N_Perm_Mgmt")}
                                                  hideNewIcon={true}
                                                  hideDeleteIcon={true}
                                                  searchTooltip={t("I18N_Search")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'OrgAdminGeneralDeleteAccess'}
                                                  objListPostProcessing={objListPostProcessing}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <PermissionAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
{/*
      {(uiMode === 'NEW')     ? <PermissionAdminNewView     onUIMode={setUIMode} />                                          : null}
*/}

    </Fragment>
  )
}

export default PermissionAdmin;
